<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import providerApi from '@/services/api/provider.api'
import therapyApi from '@/services/api/thrpy.api'
import locationServices from '@/services/api/location.api'
import appointmentsServices from '@/services/api/appointments.api'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Facturas Sometidas',
      routes: ["Informes", "Facturas Sometidas"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          centers: [],
          statuses: [],
          providers: [],
          months: [],
        },
        filters: {
          academicYear: null,
          center: null,
          status: null,
          provider: null,
          month: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Año Fiscal',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año fiscal.",
        validations: "required",
        class: "col-md-3",
        clearable: false,
        onChanged: this.onChangeAcademicYear,
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
      },
      {
        name: 'center',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Centro',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-md-3",
        options: this.model.search.collections.centers,
        value: this.model.search.filters.center,
        disabled: this.model.search.collections.centers.length <= 0,
      },
      {
        name: 'status',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Status',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-md-3",
        options: this.model.search.collections.statuses,
        value: this.model.search.filters.status,
        disabled: this.model.search.collections.statuses.length <= 0,
      },
      {
        name: 'provider',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Proveedor',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-md-3",
        options: this.model.search.collections.providers,
        value: this.model.search.filters.provider,
        disabled: this.model.search.collections.providers.length <= 0,
      },
      {
        name: 'month',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Mes',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-md-3",
        options: this.model.search.collections.months,
        value: this.model.search.filters.month,
        disabled: this.model.search.collections.months.length <= 0,
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);

      
      

      await therapyApi.getBillingStatuses()
        .then(res => this.model.search.collections.statuses = res.data);

    },
    async onChangeAcademicYear() {
      this.model.search.filters.provider = null;
      this.model.search.filters.center = null;
      this.model.search.filters.month = null;

      await this.getProvider();
      await this.getCenter();
      await this.getMonth();
    },
    async getProvider(){
      await providerApi.getAllProvidertCompaniesByYear({ academicYearId: this.model.search.filters.academicYear?.id})
      .then(res => { 
        this.model.search.collections.providers = res.data;

      });
    },
    async getCenter(){
      await locationServices.getBillingCenters({ academicYearId: this.model.search.filters.academicYear?.id})
      .then(res => { 
        this.model.search.collections.centers = res.data;
      });
    },
    async getMonth(){
      await appointmentsServices.getAppointmentsFilters({ academicYearId: this.model.search.filters.academicYear?.id})
      .then(res => { 
        this.model.search.collections.months = res.data;
      });
    },
    async onHandlerSearch() {
      

      if (this.model.search.filters.academicYear !== null &&  this.model.search.filters.academicYear !== undefined) {
        this.process();
      }
    },
    async process() {
        reportApi
          .getReport('submittedinvoices', {
            academicYearId: this.model.search.filters.academicYear?.id,
            centerId: this.model.search.filters.center?.id,
            statusId: this.model.search.filters.status?.id,
            companyId: this.model.search.filters.provider?.id,
            monthNumber: this.model.search.filters.month?.id,
          })
          .then((res) => {
            DocumentsService.Download(res.data);
          });
    },
  },
}
</script>